import { getSupabase } from '@/lib/supabase'

/**
 * Google OAuth via Supabase (PKCE). After Google authenticates, Supabase redirects
 * back to `redirectTo`, which MUST be in the Supabase Auth redirect allowlist
 * (Site URL / Redirect URLs). The Google client's authorized redirect URI is the
 * Supabase callback: https://<ref>.supabase.co/auth/v1/callback
 */
export async function signInWithGoogle(): Promise<void> {
  const { error } = await getSupabase().auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: `${window.location.origin}/` },
  })
  if (error) throw error
}

export async function signOut(): Promise<void> {
  const { error } = await getSupabase().auth.signOut()
  if (error) throw error
}
